/**
 * Fetches legal area container data for a specific delivery key.
 *
 * This composable retrieves legal content from the CMS API based on the provided delivery key,
 * current locale, and optional query parameters.
 *
 * @param {string} deliveryKey - The key used to identify the specific legal area content
 * @returns {Promise<FetchResult>} A promise resolving to the fetched legal area container data
 *
 * @example
 * const { data } = await useLegalAreaContainer('termsAndConditions')
 * console.log(data.value.content) // Displays the legal area content
 */
export const useLegalAreaContainer = async (deliveryKey: string) => {
  const localePath = useLocalePath()

  const query = {
    locale: localePath(''),
    vse: useRoute().query.vse,
    contentId: useRoute().query.contentId,
    deliveryKey: deliveryKey,
  }

  const data = await useFetch('/api/cms/getLegalAreaContainer', {
    key: 'getLegalAreaContainer' + deliveryKey,
    dedupe: 'defer',
    query,
    getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
  })

  return data
}
